export const FETCH_START = 'FETCH_START';
export const SHOW_ALERT_MESSAGE = "SHOW_ALERT_MESSAGE";
export const HIDE_ALERT_MESSAGE = "HIDE_ALERT_MESSAGE";
export const FETCH_ERROR = "FETCH_ERROR";